import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { UpsellModalEl } from "common/widgets/upsell-modal";
import { HORIZONTAL_CONTENT_PADDING_STYLE } from "common/report/layout/content-layout";
import { FullWidthReport } from "../fullwidth-report";
export function template() {
  const canUseResizingLayoutVal = FullWidthReport.canUseResizingLayout();
  return /* @__PURE__ */ jsx("div", {
    sel: ".oda-control"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".footer",
    class: {
      "resizing-layout": canUseResizingLayoutVal
    },
    style: {
      "--horizontal-padding": HORIZONTAL_CONTENT_PADDING_STYLE
    }
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".analyze-btn",
    attrs: {
      disabled: this.attr(`is-waiting-for-schedule-analysis`),
      icon: this.attr(`is-waiting-for-schedule-analysis`) ? `spinner` : `segment`,
      theme: ButtonTheme.Tertiary
    },
    on: { click: this.attr(`show-upsell`) ? this.helpers.handleClickUpsell : this.helpers.handleClickAnalyze }
  }, this.attr(`show-upsell`) ? `Upgrade to Find Interesting Segments` : `Find Interesting Segments`), /* @__PURE__ */ jsx("div", {
    sel: ".analyze-description"
  }, this.attr(`description`))), this.state.isUpsellModalOpen ? /* @__PURE__ */ jsx(UpsellModalEl, {
    attrs: {
      closeable: true,
      description: this.attr(`upsell-description`),
      "feature-gate-type": `oda`,
      header: `Find statistically significant segments`,
      "learn-more-button-url": `https://help.mixpanel.com/hc/en-us/articles/360031788492-Find-Interesting-Segments`,
      open: true
    },
    on: {
      change: this.helpers.handleChangeUpsellModal
    }
  }) : null);
}
